import _ from 'lodash'
import appConf from '../../../../conf/appConf'

// refer to ../SecretDashboard handling cookie checking
// returning 40100007 `se` cookie not valid
const seCookieError = {
  code: 40100007,
  message: 'Cookie失效，請重新登入',
  debug: `Missing cookie ${appConf.seCookieKey}`
}

export const checkSeCookie = (cookies) => {
  const seCookie = _.get(cookies, appConf.seCookieKey, null)
  const isEmptyCookie = _.isEmpty(seCookie)
  if (isEmptyCookie) {
    return { error: seCookieError }
  }

  return {}
}
